/**
 * The sync store module contains data about a sync that is in progress.
 */
export function createSyncStore() {
    return {
        namespaced: true,
        state: {
            /**
             * Is a sync currently in progress?
             */
            syncing: false,

            /**
             * An error message about the most recent sync.
             */
            error: null,

            /**
             * The name of the syncer currently running.
             *
             * @type {?string}
             */
            syncerName: null,

            /**
             * How many items need to be processed in total for the current sync?
             *
             * @type {number}
             */
            totalItems: 0,

            /**
             * @type {number}
             */
            completeItems: 0,

            /**
             * @type {number}
             */
            percentComplete: 0,

            /**
             * @type {?string}
             */
            currentItem: null,

            /**
             * @type {?string}
             */
            lastItem: null,
        },
        mutations: {
            reset(state) {
                state.syncing = false;
                state.error = null;

                state.syncerName = null;
                state.totalItems = 0;
                state.completeItems = 0;
                state.percentComplete = 0;
                state.currentItem = null;
                state.lastItem = null;
            },

            /**
             * @param {{}} state
             * @param {boolean} value
             */
            setSyncing(state, value) {
                state.syncing = !!value;
            },

            /**
             * @param {{}} state
             * @param {?Error} error
             */
            setError(state, error) {
                state.error = error;
            },

            setProgress(state, { syncerName, totalItems, completeItems, currentItem, lastItem }) {
                state.syncerName = syncerName;
                state.totalItems = totalItems;
                state.completeItems = completeItems;
                state.percentComplete = Math.round((completeItems / totalItems) * 100);
                state.currentItem = currentItem;
                state.lastItem = lastItem;
            },
        },
    };
}
